export const featureKey = 'init';
